import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { araRegelungenSelector, araRegelungenByArtSelector } from 'store/lookups/selector';

interface AraRegelungProps {
    label: string;
    disabled: boolean;
    value: number;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: number) => void;
}

export const AraRegelung: React.FC<AraRegelungProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const araRegelungen = useSelector(araRegelungenSelector);
    const araRegelungenByArt = useSelector(araRegelungenByArtSelector);

    const options = React.useMemo(() => {
        const o = araRegelungen
            .sort((a, b) => b.art - a.art)
            .map((a) => ({
                value: a.art.toString(),
                label: a.text,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [araRegelungen, allowEmpty]);

    return (
        <>
            <Label>{label}</Label>
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: araRegelungenByArt[value]?.text || value.toString(),
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(parseInt(option?.value || '0', 10));
                }}
            />
        </>
    );
};
